import { LayoutChangeEvent, StyleSheet, Text, View } from 'react-native'
import MenuIcon from './assets/Menu.svg'
import AudioVideo from './assets/AudioVideo.svg'
import { observer } from 'mobx-react-lite'
import ChatPreview from '../ChatPreview/ChatPreview'
import { IconButton } from '../IconButton'
import { useStore } from '../../../models'
import { useGameBottomModal } from '../../../screens/new-design/hooks/useGameBottomModals'
import { useShortcuts } from '../../../screens/new-design/hooks'
import { useDrawerStore } from '@/components/Drawer/Drawer'
import { DS } from '../../../design-system'
import { useCheatSheet } from '../../CheatSheet/useCheatSheet'
import { useThrottledCallback } from 'use-debounce'
import { useCallback, useState } from 'react'

export const Shortcuts = observer(() => {
  const {
    game: { isPrivateGame, isWalkthrough, isMyPlayerObserver, isMyPlayerTeacher, setIsCallOptionsModalOpen }
  } = useStore()
  const { handleVideo } = useShortcuts()
  const { openDrawer } = useDrawerStore()

  const onMenu = () => openDrawer()

  const [handRankingButtonWidth, setHandRankingButtonWidth] = useState(24)

  const { handleOpenChats: onChat } = useGameBottomModal()

  const { open: openCheatSheet } = useCheatSheet()
  const onOpenCheatSheet = useThrottledCallback(() => {
    openCheatSheet()
  }, 350)

  const onLayoutHandRankingButton = useCallback((e: LayoutChangeEvent) => {
    setHandRankingButtonWidth(e.nativeEvent.layout.width)
  }, [])

  const showVideo = isPrivateGame && (!isMyPlayerObserver || (isMyPlayerTeacher && isMyPlayerObserver))

  return (
    <View>
      <View style={[styles.display, styles.container]}>
        <View style={{ flexDirection: 'row', gap: 12 }}>
          {showVideo ? (
            <>
              <IconButton
                onPress={() => {
                  handleVideo()
                  setIsCallOptionsModalOpen(true)
                }}
              >
                <AudioVideo />
              </IconButton>
              <View style={{ height: 24, width: handRankingButtonWidth || 24 }} />
            </>
          ) : (
            <>
              <View style={{ height: 24, width: handRankingButtonWidth || 24 }} />
              <View style={{ height: 24, width: 24 }} />
            </>
          )}
        </View>

        <View style={{ alignItems: 'center', flex: 1 }}>
          <ChatPreview onChat={onChat} />
        </View>

        <View style={{ flexDirection: 'row', gap: 12 }}>
          <IconButton onPress={onOpenCheatSheet} onLayout={onLayoutHandRankingButton}>
            <DS.Center style={{ flexDirection: 'row', gap: 4 }}>
              <DS.Text variant="Caption/Regular" color="Global/White">
                Key
              </DS.Text>
              <DS.Icon name="Key" size={24} color={'Global/White'} />
            </DS.Center>
          </IconButton>
          <IconButton onPress={onMenu}>
            <MenuIcon />
          </IconButton>
        </View>
      </View>
      {isWalkthrough && <View style={{ height: 54 }} />}
    </View>
  )
})

const styles = StyleSheet.create({
  display: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  container: {
    paddingVertical: 10,
    paddingHorizontal: 8
  }
})
